/**
 * @generated SignedSource<<f8d2d9c7231bb8069e7911c0c117fb41>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TopBar_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AccountNav_viewer" | "CartNav_viewer" | "DisplaySettingsModal_viewer" | "Likes_viewer" | "Notifications_initialViewer" | "Notifications_viewer" | "SearchBar_viewer">;
  readonly " $fragmentType": "TopBar_viewer";
};
export type TopBar_viewer$key = {
  readonly " $data"?: TopBar_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TopBar_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "hasSessionCountryCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TopBar_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CartNav_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Likes_viewer"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "hasSessionCountryCode",
          "variableName": "hasSessionCountryCode"
        }
      ],
      "kind": "FragmentSpread",
      "name": "Notifications_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Notifications_initialViewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SearchBar_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AccountNav_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DisplaySettingsModal_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f4dc4a1f4e93671c5ef2bd93b7cb8795";

export default node;
